import React, { ReactElement, useContext, useEffect, useRef } from 'react'
import { AppContext } from '../contexts/AppContext'
import UserNavBar, { UserNavBarToggleButton } from './UserNavBar'
import { faBars, faCalendarWeek, faChartBar, faListOl, faMagnifyingGlass, faPenFancy } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import NavBarButton from './NavBarButton'
import { isUsingField } from '../contexts/app/auth'
import NavNotificationBar from './NavNotificationBar'
library.add(faBars, faPenFancy, faChartBar, faListOl, faCalendarWeek, faMagnifyingGlass)

const NavBar = (): ReactElement =>
    <>
        <div id="nav-bar-wrapper">
            <UbiquitousNavBar />
        </div>
        <ToggledNavBars />
        <NavNotificationBar spacingOnly={ true } />
    </>

const ToggledNavBars = (): ReactElement => {
    const { appState, appDispatch } = useContext(AppContext)
    const menuRef = useRef<HTMLDivElement>(null)
    const shown = appState.menuShown === 'user-nav-bar'
    // While open, dismiss the menu on an outside click or Escape; keep focus in the menu region.
    useEffect(() => {
        if (!shown) {
            return
        }
        const toggle = () => document.getElementById('user-nav-bar-toggle-icon')
        const close = () => appDispatch({ type: 'DISABLE_NAV_BAR_MENUS' })
        const onPointerDown = (e: MouseEvent) => {
            const target = e.target as Node
            // The toggle handles its own close, so ignore clicks on it to avoid a re-open/close race.
            if (!menuRef.current?.contains(target) && !toggle()?.contains(target)) {
                close()
            }
        }
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                close()
                toggle()?.focus()
            }
        }
        document.addEventListener('mousedown', onPointerDown)
        document.addEventListener('keydown', onKeyDown)
        menuRef.current?.focus()
        return () => {
            document.removeEventListener('mousedown', onPointerDown)
            document.removeEventListener('keydown', onKeyDown)
        }
    }, [shown, appDispatch])
    return (
        <div id="nav-and-notification-bar-wrapper">
            <NavNotificationBar />
            <div id="toggled-nav-bar-wrapper">
                <div
                    id="user-nav-bar"
                    ref={ menuRef }
                    tabIndex={ -1 }
                    className={ 'nav-bar toggled-nav-bar' + (shown ? ' toggled' : '') }>
                    <UserNavBar />
                </div>
            </div>
        </div>)
}

const UbiquitousNavBar = (): ReactElement => {
    const { appState } = useContext(AppContext)
    return <div id="nav-bar" className="nav-bar">
        <NavBarButton icon="pen-fancy" target="/write" isOnPageNavBar={ true } default={ true } text="Write" />
        <NavBarButton icon="list-ol" target="/explore" isOnPageNavBar={ true } text="Explore" />
        { isUsingField('type', appState) && <NavBarButton icon="calendar-week" target="/spans" text="Spans" /> }
        <NavBarButton icon="magnifying-glass" target="/search" isOnPageNavBar={ true } text="Search" />
        <UserNavBarToggleButton />
    </div>
}

export default NavBar
